import { Component, EventEmitter, input, Output } from '@angular/core';
import { DetailsElementData } from '../Details';
import { PasfotoComponent } from '../../shared/components/pasfoto/pasfoto.component';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-detail-panel',
	templateUrl: './detail-panel.component.html',
	styleUrls: ['./detail-panel.component.scss'],
	imports: [PasfotoComponent, IconComponent],
})
export class DetailPanelComponent {
	readonly detailsData = input<DetailsElementData | undefined>(undefined);
	readonly type = input.required<string>();
	readonly showNext = input.required<boolean>();
	readonly showPrevious = input.required<boolean>();

	@Output()
	changeElement: EventEmitter<boolean> = new EventEmitter<boolean>();
}
